import { Spacing } from '@persona-id/design-tokens';
import styled from 'styled-components';

import ClickableDetail from 'dashboard/components/ClickableDetail';
import { ReportCustomListDetails } from 'dashboard/components/ReportCustomListDetails';
import { ReportRun } from 'dashboard/models/report-run';
import ReportRunModuleHeader from 'dashboard/modules/ResourceReportRun/ReportRunModuleHeader';
import Card from 'design-system/components/Card';
import { headingMixins } from 'design-system/mixins/text';
import useCurrentEnvironmentType from 'lib/hooks/useCurrentEnvironmentType';
import { ApiModel } from 'lib/interfaces/api';

interface ReportRunDetailProps {
  reportRun: ReportRun;
  accordion?: boolean;
  isDefaultOpen?: boolean;
}

const getResult = (reportRun: ReportRun) => {
  switch (reportRun.type) {
    case ApiModel.ReportRunCustomList:
      return <ReportCustomListDetails reportRun={reportRun} multiCardFormat={false} />;
    default:
      return <> Report does not support report runs! </>;
  }
};

const AccordionTitleContainer = styled.div`
  ${headingMixins.sm};

  display: flex;
  align-items: center;
  flex-grow: 1;
  margin-right: ${Spacing[2]};
`;

const StyledCardHeaderAccordian = styled(Card.Title)`
  margin-bottom: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const StyledCardHeader = styled(Card.Title)`
  padding: ${Spacing[5]};
  margin-bottom: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;

  border-bottom: 1px solid ${({ theme }) => theme.color.border.primary};
`;

const ReportContent = styled.div`
  padding: 0 ${Spacing[2]};
`;

const ReportRunDetailsSummary = ({
  reportRun,
  accordion = false,
  isDefaultOpen = true,
}: ReportRunDetailProps) => {
  const { name: environmentName } = useCurrentEnvironmentType();

  return accordion ? (
    <ClickableDetail
      header={
        <AccordionTitleContainer
          data-test={`report-details-summary__title--${reportRun.type}--${environmentName}`}
        >
          <StyledCardHeaderAccordian>
            <ReportRunModuleHeader reportRun={reportRun} />
          </StyledCardHeaderAccordian>
        </AccordionTitleContainer>
      }
      isDefaultOpen={isDefaultOpen}
      key={reportRun.id}
    >
      <ReportContent>
        <Card.SectionHeader>Results</Card.SectionHeader>
        {getResult(reportRun)}
      </ReportContent>
    </ClickableDetail>
  ) : (
    <Card data-test={`report_runs__${reportRun.id}`}>
      <StyledCardHeader>
        <ReportRunModuleHeader reportRun={reportRun} />
      </StyledCardHeader>
      <Card.Body>
        <Card.SectionHeader>Results</Card.SectionHeader>
        {getResult(reportRun)}
      </Card.Body>
    </Card>
  );
};

export default ReportRunDetailsSummary;
